import { create } from "zustand";
import { toast } from "sonner";

export const useBasket = create((set, get) => ({
  legs: [],
  open: false,
  setOpen: (open) => set({ open }),
  add: (leg) => {
    if (get().legs.length >= 20) { toast.error("A basket can hold at most 20 orders"); return; }
    set({ legs: [...get().legs, { id: Math.random().toString(36).slice(2), product: "NRML", order_type: "MARKET", lots: 1, price: 0, ...leg }], open: true });
  },
  setLegs: (legs) => set({ legs: legs.slice(0, 20) }),
  update: (id, patch) => set({ legs: get().legs.map((l) => (l.id === id ? { ...l, ...patch } : l)) }),
  remove: (id) => set({ legs: get().legs.filter((l) => l.id !== id) }),
  clear: () => set({ legs: [] }),
}));

export const toOrders = (legs, meta) => legs.map((l) => ({
  instrument_key: l.key, side: l.side, product: l.product, order_type: l.order_type,
  quantity: Math.max(1, Number(l.lots) || 1) * (meta[l.key]?.lot_size || 1),
  price: l.order_type === "LIMIT" ? Number(l.price) || 0 : 0,
}));
